import GLightbox from '../../node_modules/glightbox/dist/js/glightbox.js';
require('../../node_modules/glightbox/dist/css/glightbox.css');

document.addEventListener('DOMContentLoaded', ()=> {
    document.querySelectorAll('.js-glightbox').length > 0 ? GLightbox({ 
        selector: '.js-glightbox',
        draggable: false
    }) : false;
    
/*
    document.querySelectorAll('a.video').length > 0 ? GLightbox({ 
        selector: 'a.video',
    }) : false;
*/

}, false);
